import * as z from "zod/v4";

export const getStripeConnectedAccount = {
  name: "getStripeConnectedAccount" as const,
  input: z.any(),
  output: z.object({
    connectedAccountId: z.string().nullish(),
    status: z.string().nullish(),
    onboarded: z.boolean(),
  }),
};
